<template>
  <div class="navigationSeventh">
    <div class="navigationSevenths">
      <div class="nav">
        <div class="b">
          <div class="l">
            <img style=" height: 64px;" :src="logo" />

          </div>
          <div class="r">
            <div  @click="goNext('/')">首页
              <div style="width: 36px;" v-if="activeIndex=='/'" class="line"></div>
            </div>
            <div @click="goNext('/xx')">学校概况
              <div v-if="activeIndex=='/xx'" class="line"></div>

            </div>
            <div @click="goNext('/xwzx')">新闻资讯
              <div v-if="activeIndex=='/xwzx'" class="line"></div>

            </div>
            <div @click="goNext('/allcurriculum/typeclass')">选课中心
              <div v-if="activeIndex=='/allcurriculum/typeclass'" class="line"></div>

            </div>
            <div @click="goNext('/all/mycurriculum')">学习中心
              <div v-if="activeIndex=='/all/mycurriculum'" class="line"></div>

            </div>
            <div @click="goNext('/lx')">联系我们
              <div v-if="activeIndex=='/lx'" class="line"></div>

            </div>
            <div v-if="!tok" @click="showLogin = true" style="cursor: pointer;" class="lo">
              <span>登录</span>

            </div>
            <div v-else @click="clogin" class="llo">
              <img :src="ruleForm && ruleForm.headPortrait ? ruleForm.headPortrait : ''" alt="">
              <img style="width: 16px;height: 16px;margin-left: 22px;margin-right: 4px;"
                src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x19.png" alt="">
              退出
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog width="380px" class="gf-navigation-login-dialog" :show-close="false"
      :visible.sync="showLogin" :before-close="handleClose" append-to-body>
      <gf-login v-if="showLogin" :key="newloginKey" @toHome="toHome" @toRegister="toRegister"
        @showForgot="showForgot"></gf-login>
    </el-dialog>
  </div>
</template>

<script>
import gfLogin from "@/components/gf/bannerLogin.vue";
import Bus from "@/api/bus";
import { getToken, getInfo, getDomain } from "@/api/cookies";
export default {
  components: { gfLogin, },
  data() {
    return {
      userInfo: null,
      ruleForm: {
        img: "",
      },
      showRegister: false,
      showLogin: false,
      activeIndex: "/",
      newloginKey: 0,
      token: "",
      tok: false,
      logo: "",
    };
  },

  async created() {
    this.activeIndex = this.$route.path;
    this.userInfo = getDomain();
    this.logo = this.userInfo && this.userInfo.logoImg ? this.userInfo.logoImg : "";
    this.userId = localStorage.getItem("userId");
    this.token = getToken();
    this.tok = Boolean(this.token);
    this.ruleForm = getInfo() || { img: "" };
    this.getTodayDate();
    Bus.$on('handleLogin', (item) => {
      if (item) {
        this.cacheVal = item
      }
      this.showLogin = true
    })
  },
 watch: {
    // 使用这个可以监听data中指定数据的变化,然后触发watch中对应的function的处理
    $route: function (newVal, oldVal) {
      console.log(newVal.path,'newVal.path');
      this.activeIndex = newVal.path;
    },
  },
  methods: {
      // 点击退出登录
    async clogin() {
      const DomainAuthorization = localStorage.getItem("DomainAuthorization");
      const domain = localStorage.getItem("domain");
      localStorage.clear();
      if (DomainAuthorization) {
        localStorage.setItem("DomainAuthorization", DomainAuthorization);
      }
      if (domain) {
        localStorage.setItem("domain", domain);
      }

      window.location.reload();
      this.$router.replace(`/`);
    },
    handleClose() {
      this.newloginKey += 1
      if (this.cacheVal == 'mustBack') {
        this.$router.go(-1)
      }
      this.showLogin = false
    },
    closes() {

      this.showLogin = false
      this.showForgotDialog = false

    },
    showForgot() {
      this.showForgotDialog = true
      this.showLogin = false
    },
    toHome() {
      this.cacheVal = ''
      this.showLogin = false
    },
    toRegister() {
      this.cacheVal = ''
      this.showLogin = false
      this.showRegister = true
    },
    getTodayDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      // 拼接年月日
      this.currentDate = `${year}-${month}-${day}`;
    },
    open() {
      window.open("http://gxhh.unzs.com", "_blank");
    },

    /* 菜单切换 */
    handleSelect(key, keyPath) {
      if (key == "/0" || key == "/1" || key == "/2") {
        return;
      }
      const userInfo = getInfo();
      for (const item of this.data.chil) {
        if (key == item.path) {
          this.data.name = item.name;
          this.data.path = item.path;
          break;
        }
      }
      if (
        !userInfo &&
        (key == "/partnerPage/my/myInfo" || key == "/partnerPage/mycurriculum")
      ) {
        this.$notify({
          title: "提醒",
          message: "请您先登录~",
          offset: 100,
        });
        // Vue.prototype.goLoginView(false)
        return;
      }

      const routeUrl = this.$router.resolve({
        path: key,
      });
      window.open(key, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.navigationSeventh {
  position: relative;
  height: 90px;

  .navigationSevenths {
    width: 100%;
    height: 90px;
    background: #0F85FB;
    border-radius: 0px 0px 0px 0px;
    position: fixed;
    z-index: 9999;
    padding: 15px 0;
    border-bottom: 1px solid rgba(255,255,255,0.4);

    .nav {
      width: 1650px;
      margin: 0 auto;

      .nav_t {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .nav_l {
          span {
            font-family: MiSans, MiSans;
            font-weight: 500;
            font-size: 13px;
            color: #FFFFFF;
          }

          .q {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 13px;
            color: #FFFFFF;
            margin-left: 16px;
          }
        }

        .nav_r {
          font-family: MiSans, MiSans;
          font-weight: 500;
          font-size: 14px;
          color: #FFFFFF;
        }
      }

      .b {
        height: 64px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .l {
          width: 549px;
          height: 64px;
          border-radius: 0px 0px 0px 0px;
        }

        .r {
          width: 960px;
          display: flex;
          align-items: center;

          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 18px;
          color: #FFFFFF;

          >div {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-right: 70px;
            cursor: pointer;

            .line {
              position: absolute;
              bottom: -30px;
              width: 70px;
              height: 3px;
              background: #FFFFFF;
              border-radius: 0px 0px 0px 0px;
            }

            &:last-child {
              margin-right: 0;
            }
          }

          .lo {
            width: 80px;
            height: 40px;
            background: #FCB75D;
            border-radius: 22px 22px 22px 22px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #FFFFFF;

            .ll {
              margin: 0 10px;
              height: 14px;

              border-right: 1px solid #FFFFFF;

            }
          }
        }
      }
    }
  }
}

.flex-cc {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 110px;
  height: 28px;
  background: linear-gradient(241deg, #3696E8 0%, #3378FF 100%);
  border-radius: 4px 4px 4px 4px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  cursor: pointer;


}

.llo {
  display: flex;
  align-items: center;
  flex-direction: row !important;
cursor: pointer;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #FFFFFF;
  margin-left: 4px;

  img {

    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
}
.gf-navigation-login-dialog /deep/ .el-dialog {
  max-width: calc(100vw - 32px);
  background: #f1f4ff;
  border-radius: 14px;
  overflow: hidden;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    // 专用弹框由登录组件统一控制间距，覆盖全局弹框内边距。
    padding: 0 !important;
  }
}
</style>
